<template>
  <v-app>
    <v-main :style="imageBackground">
      <v-row>
        <!-- Columna de la imagen (visible solo en pantallas medianas y grandes) -->
        <v-col cols="0" md="7" class="image-container d-none d-md-flex">
          <v-img src="/img/iot.png" max-width="250" class="bottom-left"></v-img>
        </v-col>

        <!-- Columna del formulario -->
        <v-col col2="12" md="5">
          <slot />
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      imageBackground: `background-image: url(${require('@/assets/img/fondoLogin.png')}); background-size: cover;`,
    }
  }
}
</script>

<style scoped>
.image-container {
  display: flex;
  justify-content: flex-start; /* Alinear horizontalmente a la izquierda */
  align-items: flex-end; /* Alinear verticalmente en la parte inferior */
  height: 100vh; /* Ocupar toda la altura de la pantalla */
}

.bottom-left {
  margin-left: 20px; /* Ajustar margen si es necesario */
  margin-bottom: 20px; /* Ajustar margen inferior si es necesario */
}
</style>
